{
  "title": "Alustava takaisinmaksusuunnitelma",
  "disclaimer": "Tämä takaisinmaksusuunnitelma on suuntaa-antava arvio ja tarkoitettu vain alustavaksi tiedoksi. Lopulliset kustannukset ja maksuerät voivat vaihdella rahoittajan lopullisten ehtojen mukaisesti.",
  "exportToExcel": "Vie Exceliin",
  "exporting": "Viedään…",
  "tabs": {
    "table": "Taulukko",
    "graph": "Kaavio"
  },
  "month": "Kuukausi",
  "payment": "Kuukausierä",
  "interest": "Korko",
  "principal": "Lyhennys",
  "fees": "Kulut",
  "remainingBalance": "Jäljellä oleva lainasumma",
  "total": "Yhteensä",
  "setupFee": "Toimitusmaksu",
  "totalRepaid": "Takaisinmaksettava kokonaissumma",
  "totalCostOfCredit": "Rahoituksen kokonaiskustannukset",
  "loading": "Ladataan…",
  "totalsTitle": "Yhteensä",
  "slider": {
    "label": "Laina-aika",
    "originalTerm": "Alkuperäinen laina-aika"
  },
  "savings": {
    "title": "Mahdollinen säästö ennenaikaisella takaisinmaksulla",
    "interestSaved": "Säästetty korkomaksu",
    "feesSaved": "Säästetyt kulut",
    "grossSaved": "Säästö yhteensä (brutto)",
    "earlyRepaymentFee": "Ennenaikaisen takaisinmaksun kulu",
    "repaidEarlier": "Maksettu {{duration}} aiemmin – suuntaa-antava laskelma, jossa oletetaan, että koko loppulaina maksetaan pois kuukauden lopussa."
  },
  "tooltips": {
    "setupFee": "Kertaluonteinen maksu, joka veloitetaan, kun laina nostetaan. Näkyy kuukautena 0.",
    "totalCostOfCredit": "Kaikki, mitä laina maksaa lainatun summan lisäksi (kaikki korot ja kulut yhteensä).",
    "totalRepaid": "Koko summa, jonka maksat takaisin laina-aikana: lainattu summa + lainan kokonaiskustannukset",
    "interestSaved": "Korko, jolta vältyt maksamalla lainan takaisin aikaisemmin koko laina-ajan sijaan.",
    "feesSaved": "Toistuvat kuukausimaksut (kuten laskutus- ja tilinhoitokulut), joilta vältyt säästämiltäsi kuukausilta.",
    "grossSaved": "Säästetty korko ja säästetyt kulut yhteensä, ennen kuin mahdollinen ennenaikaisen takaisinmaksun kulu vähennetään.",
    "earlyRepaymentFee": "Maksu, jonka lainanantaja voi periä, jos laina maksetaan kokonaan pois ennen laina-ajan päättymistä."
  }
}
